import { api, ensureCsrf, unwrap } from './client';
import type { components } from './schema';

export type Me = components['schemas']['Me'];

export async function fetchMe(): Promise<Me | null> {
  const r = await api.GET('/api/auth/me');
  if (r.response.status === 403) return null;
  return unwrap(r);
}
export async function login(email: string, password: string): Promise<Me> {
  await ensureCsrf();
  return unwrap(await api.POST('/api/auth/login', { body: { email, password } }));
}
export async function logout(): Promise<void> {
  unwrap(await api.POST('/api/auth/logout'));
}
export async function updateMe(patch: Partial<Pick<Me, 'full_name' | 'locale'>>): Promise<Me> {
  return unwrap(await api.PATCH('/api/auth/me', { body: patch }));
}
export async function requestPasswordReset(email: string): Promise<void> {
  await ensureCsrf();
  unwrap(await api.POST('/api/auth/password-reset', { body: { email } }));
}
export async function confirmPasswordReset(uid: string, token: string, password: string): Promise<void> {
  await ensureCsrf();
  unwrap(await api.POST('/api/auth/password-reset/confirm', { body: { uid, token, password } }));
}

export type ConsentDetails = components['schemas']['ConsentDetails'];

/** What an MCP host is asking for, from the signed `req` the authorize endpoint issued. */
export async function fetchConsent(req: string): Promise<ConsentDetails> {
  return unwrap(await api.GET('/api/oauth/consent', { params: { query: { req } } }));
}
/** The user's decision; resolves to where the browser must go next. */
export async function decideConsent(req: string, allow: boolean): Promise<string> {
  await ensureCsrf();
  const r = unwrap(await api.POST('/api/oauth/consent', { body: { req, allow } }));
  return r.redirect_to;
}
